var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "255mm",
    viewBox: "0 0 255 255",
    width: "255mm",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b23339",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.591 75.404h57.415v169.793H38.86V75.053h59.866M128.316 8.361v159.817M86.651 50.026l41.665-41.665 42.003 42.003"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.9637d9aa924bb90be63a0a75d3022b4b.svg";
export { ForwardRef as ReactComponent };